export const WORKFLOWS_PATH = '/workflows';
export const CREATE_WORKFLOW_PATH = `${WORKFLOWS_PATH}/create`;
export const EDIT_WORKFLOW_PATH = `${WORKFLOWS_PATH}/edit`;
